var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHeading(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M448 448C448 465.672 433.674 480 416 480H320C302.326 480 288 465.672 288 448C288 430.326 302.326 416 320 416V288H128V416C145.674 416 160 430.326 160 448C160 465.672 145.674 480 128 480H32C14.326 480 0 465.672 0 448C0 430.326 14.326 416 32 416V96C14.326 96 0 81.672 0 64C0 46.326 14.326 32 32 32H128C145.674 32 160 46.326 160 64C160 81.672 145.674 96 128 96V192H320V96C302.326 96 288 81.672 288 64C288 46.326 302.326 32 320 32H416C433.674 32 448 46.326 448 64C448 81.672 433.674 96 416 96V416C433.674 416 448 430.326 448 448Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeading);
export default __webpack_public_path__ + "static/media/heading.60f2778f58d42679cdeefb40002d449f.svg";
export { ForwardRef as ReactComponent };